import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { action, IReactionDisposer, observable, reaction, runInAction, when, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import EstruturaService from '../../assistente-minutas/services/EstruturaService';
import EscaninhoService from '../../services/EscaninhoService';
import ControleGabineteStore from '../../store/ControleGabineteStore';
import { AppStore } from '../../store/AppStore';
import GabineteStore from '../../store/GabineteStore';
import ProcessoStore from '../../store/ProcessoStore';
import ImportacaoProcessosStore from '../../store/ImportacaoProcessosStore';
import RouterStore from '../../store/RouterStore';
import Kanban from './Kanban';
import AvisoAtualizacoesPendentes from './AvisoAtualizacoesPendentes';
import ControleGabineteService from '@/services/ControleGabineteService';
import UsuarioStore from '@/store/UsuarioStore';
import Modal from '@/misc/Modal';
import BotaoFiltrarOJC from './BotaoFiltrarOJC';
import SearchBar from './SearchBar';
import { Check, ColorLens, Padding, Palette, Save, Settings } from '@mui/icons-material';

interface IPropsControleGabinete {

};


class ControleGabinete extends React.Component<IPropsControleGabinete> {
    readonly exibirModalNovidades = true;
    stepIndex = 0;
    modalCriarControlesPadrao = false;
    mostrarModalNovidades = false;
    intervaloAtualizacao;
    timeoutPrimeiroRefresh?: number;
    timeoutSemContextoUsuario?: number;
    gabineteReactionDisposer?: IReactionDisposer;
    requisicoesReactionDisposer?: IReactionDisposer;
    processosReactionDisposer?: IReactionDisposer;
    carregamentoInicialReactionDisposer?: IReactionDisposer;
    listaControlesReactionDisposer?: IReactionDisposer;
    tentativasAutoRefresh = 0;
    ultimoAutoRefreshMs = 0;
    houvePendenciasControle = false;
    recargasPorPendenciaExecutadas = 0;
    readonly maxRecargasPorPendencia = 2;
    atualizandoControlesLocal = false;
    carregandoProcessosFallback = false;
    controlesSnapshot = [];
    versaoRenderKanban = 0;
    assinaturaSnapshotControles = '';
    carregamentoProcessosDetectadoEm = 0;
    carregamentoInicialIniciado = false;
    carregamentoInicialConcluido = false;

    constructor(props: IPropsControleGabinete) {
        super(props);

        makeObservable(this, {
            stepIndex: observable,
            modalCriarControlesPadrao: observable,
            mostrarModalNovidades: observable,
            atualizandoControlesLocal: observable,
            carregandoProcessosFallback: observable,
            controlesSnapshot: observable,
            versaoRenderKanban: observable,
            carregamentoInicialIniciado: observable,
            carregamentoInicialConcluido: observable,
            sincronizarSnapshotControles: action,
            handleNext: action,
            handleClose: action,
            handlePrev: action,
            criarControlesPadrao: action,
            fecharModalNovidades: action
        });
    }

    sincronizarSnapshotControles = () => {
        const lista = ControleGabineteStore.listaDeControles.slice();
        lista.sort((a, b) => a.numeroOrdem - b.numeroOrdem);

        const novaAssinatura = lista
            .map((controle) => `${controle.numero}-${controle.numeroOrdem}-${controle.ativo}`)
            .join('|');

        this.controlesSnapshot = lista;

        // Evita remount do Kanban em atualizacoes sem mudanca estrutural
        // (ex.: requisicoes pendentes da modal de importacao), mantendo a modal aberta.
        if (novaAssinatura !== this.assinaturaSnapshotControles) {
            this.assinaturaSnapshotControles = novaAssinatura;
            if (!ImportacaoProcessosStore.abertoModalImportacao) {
                this.versaoRenderKanban++;
            }
        }
    }

    atualizarControlesComSync = async () => {
        if (this.atualizandoControlesLocal) {
            return;
        }

        runInAction(() => {
            this.atualizandoControlesLocal = true;
        });

        try {
            const controles = await ControleGabineteService.atualizarControlesGabinete();

            if (controles && controles.length > 0) {
                runInAction(() => {
                    ControleGabineteStore.listaDeControles = controles;
                    ControleGabineteStore.controlesCarregados = true;
                    ControleGabineteStore.carregandoControles = false;
                });
            }

            this.sincronizarSnapshotControles();
        } finally {
            runInAction(() => {
                this.atualizandoControlesLocal = false;
            });
            this.forceUpdate();
        }
    }

    carregarProcessosFallback = async () => {
        const processosJaDisponiveis = ProcessoStore._processos.length > 0;
        const carregamentoConcluidoComDados = ProcessoStore.carregouProcessosNoEscaninho && processosJaDisponiveis;

        if (this.carregandoProcessosFallback || ProcessoStore.carregandoProcessosNoEscaninho || carregamentoConcluidoComDados) {
            return;
        }

        runInAction(() => {
            this.carregandoProcessosFallback = true;
        });

        try {
            await EscaninhoService.carregarProcessosDoGabinete();
            this.sincronizarSnapshotControles();
        } catch (error) {
            console.error('Falha no fallback de carregamento de processos do Controle de Gabinete.', error);
        } finally {
            runInAction(() => {
                this.carregandoProcessosFallback = false;
            });
        }
    }

    forcarRecargaProcessos = async () => {
        if (this.carregandoProcessosFallback) {
            return;
        }

        runInAction(() => {
            this.carregandoProcessosFallback = true;
        });

        try {
            await EscaninhoService.selecionaConsulta();
            this.sincronizarSnapshotControles();
        } catch (error) {
            console.error('Falha na recarga forçada de processos do Controle de Gabinete.', error);
        } finally {
            runInAction(() => {
                this.carregandoProcessosFallback = false;
            });
        }
    }

    carregarUsuariosGabineteFallback = async () => {
        if (GabineteStore.carregandoUsuariosGabinete || GabineteStore.listaUsuariosGabinete?.length > 0) {
            return;
        }

        try {
            await GabineteStore.atualizarUsuariosGabinete(UsuarioStore.gabinete);
        } catch (error) {
            console.error('Falha no fallback de carregamento dos usuários do gabinete.', error);
        }
    }

    componentWillUnmount() {
        //Limpando a barra de ações quando despuser do componenete
        clearInterval(this.intervaloAtualizacao);
        if (this.timeoutPrimeiroRefresh) {
            clearTimeout(this.timeoutPrimeiroRefresh);
        }
        if (this.timeoutSemContextoUsuario) {
            clearTimeout(this.timeoutSemContextoUsuario);
        }
        if (this.gabineteReactionDisposer) {
            this.gabineteReactionDisposer();
        }
        if (this.requisicoesReactionDisposer) {
            this.requisicoesReactionDisposer();
        }
        if (this.processosReactionDisposer) {
            this.processosReactionDisposer();
        }
        if (this.carregamentoInicialReactionDisposer) {
            this.carregamentoInicialReactionDisposer();
        }
        if (this.listaControlesReactionDisposer) {
            this.listaControlesReactionDisposer();
        }
        // Não deixa atualizações retidas (nem a pausa) para trás ao sair da tela.
        ControleGabineteStore.retomarAtualizacoes();
    }

    organizaCards = (cards) => {
        cards.map((card) => {
            card.index = card.numero;
        });
        cards.slice().sort((item1, item2) => item1.numeroOrdem - item2.numeroOrdem);

        return cards;
    }

    // Precisa ser método de protótipo, não class field de arrow function: em
    // React 19 + mobx-react 9 isso quebra a reatividade do observer() para
    // este componente permanentemente após a primeira montagem.
    componentDidMount() {
        // Corrige condicao de corrida: se o gabinete chegar depois da entrada na rota,
        // dispara recarga automaticamente para atualizar a tela sem precisar navegar.
        this.gabineteReactionDisposer = reaction(
            () => UsuarioStore.gabinete,
            (gabinete) => {
                if (!gabinete) {
                    return;
                }

                runInAction(() => {
                    this.carregamentoInicialIniciado = true;
                });

                const precisaRecarregar = !ControleGabineteStore.controlesCarregados
                    || ControleGabineteStore.listaDeControles.length === 0;

                if (precisaRecarregar) {
                    this.atualizarControlesComSync();
                }

                this.carregarProcessosFallback();
                this.carregarUsuariosGabineteFallback();
            },
            { fireImmediately: true }
        );

        // Libera os cards uma única vez, somente após as cargas específicas desta tela.
        // Atualizações posteriores acontecem em segundo plano sem substituir o Kanban pelo loading.
        this.carregamentoInicialReactionDisposer = reaction(
            () => {
                const possuiControles = this.controlesSnapshot.length > 0
                    || ControleGabineteStore.listaDeControles.length > 0;
                const controlesProntos = !ControleGabineteStore.carregandoControles
                    && !this.atualizandoControlesLocal
                    && (ControleGabineteStore.controlesCarregados || possuiControles);
                const processosProntos = ProcessoStore.carregouProcessosNoEscaninho
                    || (
                        !ProcessoStore.carregandoProcessosNoEscaninho
                        && !this.carregandoProcessosFallback
                        && !AppStore.isCarregandoTodosProcessos
                    );

                return this.carregamentoInicialIniciado
                    && !!UsuarioStore.gabinete
                    && controlesProntos
                    && processosProntos
                    && !GabineteStore.carregandoUsuariosGabinete;
            },
            (pronto) => {
                if (pronto && !this.carregamentoInicialConcluido) {
                    runInAction(() => {
                        this.sincronizarSnapshotControles();
                        this.carregamentoInicialConcluido = true;
                    });
                }
            },
            { fireImmediately: true }
        );

        // Quando todas as requisicoes globais terminarem, re-sincroniza a tela.
        // Isso cobre cenarios em que as atualizacoes chegam tarde e o observer nao repinta a tempo.
        this.requisicoesReactionDisposer = reaction(
            () => ({
                gabinete: UsuarioStore.gabinete,
                requisicoesPendentes: AppStore.requisicoesPendentes,
                carregandoProcessos: ProcessoStore.carregandoProcessosNoEscaninho
            }),
            ({ gabinete, requisicoesPendentes, carregandoProcessos }) => {
                if (!gabinete) {
                    return;
                }

                if (requisicoesPendentes) {
                    this.houvePendenciasControle = true;
                    return;
                }

                if (!requisicoesPendentes && !carregandoProcessos) {
                    const semDados = ControleGabineteStore.listaDeControles.length === 0;
                    const naoCarregado = !ControleGabineteStore.controlesCarregados;

                    if (this.houvePendenciasControle && semDados && this.recargasPorPendenciaExecutadas < this.maxRecargasPorPendencia) {
                        this.recargasPorPendenciaExecutadas++;
                        this.atualizarControlesComSync();
                        this.carregarProcessosFallback();
                        this.carregarUsuariosGabineteFallback();
                    }

                    if (!semDados && ControleGabineteStore.controlesCarregados) {
                        this.houvePendenciasControle = false;
                        this.recargasPorPendenciaExecutadas = 0;
                    }

                    if (semDados || naoCarregado) {
                        this.atualizarControlesComSync();
                        this.carregarProcessosFallback();
                    }

                    this.carregarUsuariosGabineteFallback();

                    // Depois da carga inicial, quem mantém a tela em dia são os observers e a reaction de
                    // listaControlesReactionDisposer. Repintar aqui a cada requisição que termina faz a tela
                    // "tremer" quando chegam muitas notificações do envelope.
                    if (!this.carregamentoInicialConcluido) {
                        if (ControleGabineteStore.listaDeControles.length > 0) {
                            this.sincronizarSnapshotControles();
                        }

                        this.forceUpdate();
                    }
                }
            },
            { fireImmediately: true }
        );

        // Propaga para a tela mudanças reais na lista de controles (criação, ordem, nome, configuração),
        // inclusive as vindas do envelope. Recargas sem mudança de conteúdo não disparam nada.
        this.listaControlesReactionDisposer = reaction(
            () => JSON.stringify(ControleGabineteStore.listaDeControles.slice()),
            () => {
                if (this.carregamentoInicialConcluido) {
                    this.sincronizarSnapshotControles();
                }
            }
        );

        // Em hard refresh, os processos podem chegar depois do primeiro paint.
        // Remontar o Kanban ao mudar a carga de processos replica o comportamento
        // de "sair e voltar da rota", que hoje atualiza corretamente os cards.
        // A quantidade de processos NÃO é observada aqui de propósito: o envelope adiciona/remove
        // processos o tempo todo, e remontar o Kanban a cada um reiniciava o carregamento progressivo
        // dos cards e destruía o elemento sob o cursor (o usuário não conseguia clicar).
        // Os cards já reagem sozinhos às mudanças em ProcessoStore.
        this.processosReactionDisposer = reaction(
            () => ({
                carregou: ProcessoStore.carregouProcessosNoEscaninho,
                carregando: ProcessoStore.carregandoProcessosNoEscaninho
            }),
            ({ carregou, carregando }) => {
                if (!UsuarioStore.gabinete) {
                    return;
                }

                const quantidadeProcessos = ProcessoStore._processos.length;

                if ((carregou && quantidadeProcessos >= 0) || (!carregando && quantidadeProcessos > 0)) {
                    if (!ImportacaoProcessosStore.abertoModalImportacao) {
                        this.versaoRenderKanban++;
                    }
                    this.forceUpdate();
                }
            },
            { fireImmediately: true }
        );

        // Retry curto para hard refresh: evita estado inicial travado vindo do limpar().
        this.timeoutPrimeiroRefresh = window.setTimeout(() => {
            const precisaRecarregar = !ControleGabineteStore.controlesCarregados
                && ControleGabineteStore.listaDeControles.length === 0
                && !!UsuarioStore.gabinete;

            if (precisaRecarregar) {
                this.atualizarControlesComSync();
            }
        }, 1200);

        // Em localhost/hard refresh, o contexto do usuario pode falhar e manter loading inicial travado.
        this.timeoutSemContextoUsuario = window.setTimeout(() => {
            const semGabinete = !UsuarioStore.gabinete;
            const semDados = ControleGabineteStore.listaDeControles.length === 0;

            if (semGabinete && semDados && ControleGabineteStore.carregandoControles) {
                runInAction(() => {
                    ControleGabineteStore.carregandoControles = false;
                });
            }
        }, 4000);

        // Fallback defensivo: se a lista chegar preenchida, sincroniza flags de carregamento.
        this.intervaloAtualizacao = window.setInterval(() => {
            if (ControleGabineteStore.listaDeControles.length > 0 && ControleGabineteStore.carregandoControles) {
                runInAction(() => {
                    ControleGabineteStore.carregandoControles = false;
                    ControleGabineteStore.controlesCarregados = true;
                });
            }

            if (ControleGabineteStore.listaDeControles.length > 0 && this.controlesSnapshot.length === 0) {
                this.sincronizarSnapshotControles();
            }

            if (ProcessoStore.carregandoProcessosNoEscaninho) {
                if (!this.carregamentoProcessosDetectadoEm) {
                    this.carregamentoProcessosDetectadoEm = Date.now();
                }

                const timeoutCarregamentoProcessos = Date.now() - this.carregamentoProcessosDetectadoEm > 15000;

                if (timeoutCarregamentoProcessos && ProcessoStore._processos.length === 0) {
                    runInAction(() => {
                        ProcessoStore.carregandoProcessosNoEscaninho = false;
                        ProcessoStore.carregouProcessosNoEscaninho = false;
                    });

                    this.carregamentoProcessosDetectadoEm = 0;
                    this.forcarRecargaProcessos();
                }

                if (timeoutCarregamentoProcessos && ProcessoStore._processos.length > 0) {
                    runInAction(() => {
                        ProcessoStore.carregandoProcessosNoEscaninho = false;
                        ProcessoStore.carregouProcessosNoEscaninho = true;
                    });

                    this.carregamentoProcessosDetectadoEm = 0;
                }
            } else {
                this.carregamentoProcessosDetectadoEm = 0;
            }

            const travadoEmLoading = ControleGabineteStore.carregandoControles
                && !ControleGabineteStore.controlesCarregados
                && ControleGabineteStore.listaDeControles.length === 0
                && !!UsuarioStore.gabinete;

            const passouJanelaRetry = (Date.now() - this.ultimoAutoRefreshMs) > 3000;

            if (travadoEmLoading && this.tentativasAutoRefresh < 3 && passouJanelaRetry) {
                this.tentativasAutoRefresh++;
                this.ultimoAutoRefreshMs = Date.now();
                this.atualizarControlesComSync();
                this.carregarProcessosFallback();
                this.carregarUsuariosGabineteFallback();

                const semProcessosAposRetry = ProcessoStore._processos.length === 0;
                if (semProcessosAposRetry) {
                    this.forcarRecargaProcessos();
                }
            }
        }, 400);

        ControleGabineteStore.carregarModoVisualizacaoSalvo();

        if (this.exibirModalNovidades) {
            const jaViu = localStorage.getItem(
                `cg_novidades_vistas_v2_${UsuarioStore.login}`
            );

            if (jaViu !== 'true') {
                requestAnimationFrame(() => {
                    runInAction(() => {
                        this.mostrarModalNovidades = true;
                    });
                });
            }
        }

        when(() => ControleGabineteStore.controlesCarregados == true, () => {
            if (ControleGabineteStore.listaDeControles.length === 0) {
                runInAction(() => {
                    this.modalCriarControlesPadrao = true;
                });
            }
        })

    }

    handleNext = () => {
        if (this.stepIndex < 2) {
            this.stepIndex++;
        }
    };

    handleClose = () => {
        this.modalCriarControlesPadrao = false;
    };

    handlePrev = () => {
        if (this.stepIndex > 0) {
            this.stepIndex--;
        }
    };

    criarControlesPadrao = async () => {
        // let controlesGabinete = [];
        try {
            await ControleGabineteService.criarControlesPadrao(UsuarioStore.gabinete);
            await EstruturaService.criarEstruturasPadrao();
        } catch (_error) {
            RouterStore.push('/controleGabinete');
        }
        runInAction(() => {
            // this.items = controlesGabinete;
            this.modalCriarControlesPadrao = false;
        });
    };

    fecharModalNovidades = () => {
        this.mostrarModalNovidades = false;

        localStorage.setItem(
            `cg_novidades_vistas_v2_${UsuarioStore.login}`,
            'true'
        );
    };

    renderModalNovidades() {
        const passos = [
            {
                titulo: 'Abra as configurações',
                descricao: <>Clique na engrenagem no canto superior direito da tela e selecione <b>Configurar gabinete</b>.</>,
                Icone: Settings,
            },
            {
                titulo: 'Localize o controle',
                descricao: <>No cabeçalho do controle desejado, clique na <b>paleta de cores</b>, ao lado do lápis de edição.</>,
                Icone: ColorLens,
            },
            {
                titulo: 'Escolha sua cor',
                descricao: <>Selecione a cor desejada no seletor. Você pode repetir esse passo para outros controles.</>,
                Icone: Palette,
            },
            {
                titulo: 'Grave as alterações',
                descricao: <>Clique em <b>Gravar</b> para salvar as cores escolhidas.</>,
                Icone: Save,
            },
        ];

        return (
            <Dialog
                open={this.mostrarModalNovidades}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Novidades no Controle de Gabinete</DialogTitle>

                <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <ColorLens sx={{ color: 'primary.main' }} />
                        <Typography component="h3" variant="h6" fontWeight={600}>
                            Personalize a cor dos seus controles
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Escolha a cor do cabeçalho de cada controle de listagem para
                        facilitar sua identificação.
                    </Typography>

                    <Box component="ol" sx={{ listStyle: 'none', p: 0, m: 0, display: 'grid', gap: 1.5 }}>
                        {passos.map(({ titulo, descricao, Icone }, index) => (
                            <Box
                                component="li"
                                key={titulo}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 2,
                                    p: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2,
                                    bgcolor: 'action.hover',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        width: 40,
                                        height: 40,
                                        borderRadius: 2,
                                        bgcolor: 'background.paper',
                                        color: 'primary.main',
                                    }}
                                >
                                    <Icone />
                                </Box>
                                <Box>
                                    <Typography component="h4" variant="subtitle2" sx={{ mb: 0.5 }}>
                                        {index + 1}. {titulo}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {descricao}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button
                        onClick={this.fecharModalNovidades}
                        variant="contained"
                        color="primary"
                        startIcon={<Check />}
                        disableElevation
                    >
                        Entendi
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    render() {
        const isLista = ControleGabineteStore.isVisualizacaoEmLista;
        const notSE = !UsuarioStore.gabinete.startsWith('SE');
        const possuiControles = this.controlesSnapshot.length > 0;
        const exibirLoading = !ImportacaoProcessosStore.abertoModalImportacao
            && !this.carregamentoInicialConcluido;

        return (
            <div id='controleGabinete'>
                {this.exibirModalNovidades && this.mostrarModalNovidades && this.renderModalNovidades()}
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto 1fr',
                        alignItems: 'center',
                        columnGap: '16px',
                        marginTop: notSE ? '10px' : '15px'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignSelf: 'flex-start',
                            padding: '10px',
                        }}
                    >
                        {!UsuarioStore.gabinete.startsWith('SE') && <BotaoFiltrarOJC />}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <SearchBar
                            value={ControleGabineteStore.termoBusca}
                            onChange={(valor) =>
                                ControleGabineteStore.setTermoBusca(valor)
                            }
                            buscando={ControleGabineteStore.buscando}
                            placeholder="Pesquisar controles ou servidores..."
                        />
                    </div>
                </div>
                {isLista && <div style={{ height: '20px' }} />}
                <div className="text-align-center">
                    {exibirLoading ? (
                        <Box
                            sx={{
                                minWidth: 140,
                                minHeight: 200,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'relative',
                                    width: 32,
                                    height: 32,
                                }}
                            >
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    size={32}
                                    thickness={2}
                                    sx={{ color: 'rgba(0, 0, 0, 0.15)' }}
                                />
                                <CircularProgress
                                    size={32}
                                    thickness={2}
                                    disableShrink
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        color: 'primary.main',
                                    }}
                                />
                            </Box>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                padding="5px"
                                noWrap
                            >
                                Carregando dados do controle de gabinete...
                            </Typography>
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={this.atualizarControlesComSync}
                            >
                                Recarregar controles
                            </Button>
                        </Box>
                    ) : (ControleGabineteStore.controlesCarregados || possuiControles) ?
                            this.controlesSnapshot.length === 0 ?
                            <h4 style={{ marginTop: 20, color: 'red', display: 'flex', justifyContent: 'center' }}>Não existe Controle de Gabinete configurado!</h4>
                            :
                            // Enquanto o usuário mexe o mouse, clica ou rola aqui, as atualizações do envelope ficam
                            // retidas para a tela não mudar debaixo do cursor; ao sair da área elas são aplicadas.
                            <div
                                style={{ marginTop: '10px' }}
                                onMouseMove={ControleGabineteStore.registrarInteracao}
                                onMouseDown={ControleGabineteStore.registrarInteracao}
                                onWheel={ControleGabineteStore.registrarInteracao}
                                onMouseLeave={ControleGabineteStore.retomarAtualizacoes}
                            >
                                    <Kanban key={this.versaoRenderKanban} items={this.controlesSnapshot} isConfig={false} />
                                    <AvisoAtualizacoesPendentes />
                            </div>
                        :
                        <div>
                            Erro ao carregar controles de gabinete
                        </div>
                    }
                </div>
                <Modal
                    aberto={this.modalCriarControlesPadrao}
                    fecharModal={this.handleClose}
                    titulo='Criação de Controle de Gabinete'
                    funcaoAcaoSecundaria={this.handleClose}
                    labelAcaoSecundaria='Cancelar'
                    funcaoAcaoPrimaria={this.criarControlesPadrao}
                    labelAcaoPrimaria='Criar'
                >
                    <Typography>
                        Seu Gabinete ainda não possui Controles configurados. Deseja criar agora seguindo a estrutura padrão?
                    </Typography>
                </Modal>
            </div>
        );
    }
}

export default observer(ControleGabinete);
